import * as React from 'react';
import { Component } from 'react';
import styles from '../styles/wizards/AddCompanyPositionsWizard.scss';
import autobind from 'autobind-decorator';
import { __, mapStateToProps, validateForm } from '../core/utils';
import { setNotification } from '../redux/actions/general/notification';
import { withRouter } from 'react-router';
import * as _ from 'lodash';
import Localization from '../helpers/Localization';
import { subscribe } from 'react-contextual';
import {
  createCompanyPosition,
  listCompanyPositions,
} from '../redux/actions/table/company_positions';
import AddCompanyIcon from '../assets/images/add-company-60x60.svg';
import AddCompanyPositionsForm from '../forms/add_company_positions_wizard/AddCompanyPositionsForm';

@withRouter
@mapStateToProps((state) => ({
  table: state.table['company_positions'],
}))
@subscribe(Localization, 'localization')
class AddCompanyPositionsWizard extends Component {
  @autobind
  _handleSubmit(formData) {
    return validateForm(
      createCompanyPosition(formData).then(({ response }) => {
        listCompanyPositions();

        setNotification(__('wizard.add-company-position.confirm'));

        this.props.onClose();
      })
    );
  }

  render() {
    return (
      <>
        <div className={styles.header}>
          <div className={styles.left}>
            <span>{__('wizard.add-company-positions.title.create-new')}</span>
            <span>
              {__('wizard.add-company-positions.subtitle.create-new')}
            </span>
          </div>
          <div className={styles.right}>
            <AddCompanyIcon />
          </div>
        </div>
        <div className={styles.body}>
          <AddCompanyPositionsForm onSubmit={this._handleSubmit} />
        </div>
      </>
    );
  }
}

export default AddCompanyPositionsWizard;
